// ===========================================
// Students Components - Constants
// ===========================================

/**
 * Default color for age groups that don't have a custom color
 */
export const DEFAULT_AGE_GROUP_COLOR = '#9DA5AF';

/**
 * Day names for formatting
 */
export const DAY_NAMES = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

/**
 * Default form data for a new student
 */
export const DEFAULT_STUDENT_FORM_DATA = {
  firstName: '',
  lastName: '',
  birthDate: '',
  familyId: '',
  email: '',
  phone: '',
  notes: '',
  isActive: true,
  status: 'NEW' as const,
};

/**
 * Number of notes/files to show in preview mode
 */
export const PREVIEW_ITEM_COUNT = 5;
